import { CommonAction } from '../../../../../message/redux/types';
import TeamManagementTypes, { TeamManagementState } from './types';

const teamManagementState: TeamManagementState = {
    loading: false,
    inviteLoader: false,
    teamMemberList: {
        teamName: '',
        members: [],
    },
};
const TeamManagementReducers = (state = teamManagementState, action: CommonAction): TeamManagementState => {
    switch (action.type) {
        case TeamManagementTypes.FETCH_TEAM_MEMBERS:
            return {
                ...state,
                loading: true,
                teamMemberList: {
                    teamName: '',
                    members: [],
                },
            };
        case TeamManagementTypes.SET_TEAM_MEMBERS:
            const teamMemberList = action.payload;
            return {
                ...state,
                loading: false,
                teamMemberList: teamMemberList,
            };
        case TeamManagementTypes.SUCCESS_TEAM_MEMBERS:
            return {
                ...state,
                inviteLoader: false,
            };
        case TeamManagementTypes.FAILED_TEAM_MEMBERS:
            return {
                ...state,
                loading: false,
            };
        case TeamManagementTypes.INVITE_TEAM_MEMBERS:
            return {
                ...state,
                inviteLoader: true,
            };
        case TeamManagementTypes.INVITE_TEAM_MEMBERS_FAILED:
            return {
                ...state,
                inviteLoader: false,
            };
        case TeamManagementTypes.INVITE_TEAM_MEMBERS_SUCCESS:
            return {
                ...state,
                inviteLoader: false,
            };

        default:
            return state;
    }
};
export default TeamManagementReducers;
